import { types, getRoot } from 'mobx-state-tree'
import type { IDialogs } from '../Dialog'

export const Dialogable = types
  .model('Dialogable', {})
  .views((self) => ({
    get dialogs() {
      const { dialogs } = getRoot(self) as { dialogs: IDialogs }
      return dialogs
    }
  }))
  .actions((self) => ({
    showDialog(name: string, data?: any) {
      const { dialogs } = getRoot(self) as { dialogs: IDialogs }
      dialogs.showDialog(name, data)
    },
    closeDialog(name: string) {
      const { dialogs } = getRoot(self) as { dialogs: IDialogs }
      dialogs.closeDialog(name)
    }
  }))
